import React from 'react'
import { array, bool } from 'prop-types'
import { branch } from 'baobab-react/higher-order'

import Tour from 'utils/monkey/reactour'
import API from 'utils/API'
import csrfToken from 'utils/csrfToken'
import triggerEvent from 'utils/dataLayer'
import { detectStopScroll } from 'utils/bodyScrollLock'
import isDOMAvailable from 'utils/isDOMAvailable'

import { Navbar, NavbarBrand, NavItem, NavLink, Nav, Image } from 'components/qstrap'
import HamburgerBtn from 'components/atoms/HamburgerBtn'
import OnboardingTooltip from 'components/molecules/OnboardingTooltip'
import Search from 'components/organisms/Search'
import DesktopMenu from './DesktopMenu'
import MobileMenuToggler from './MobileMenuToggler'
import MobileMenu from './MobileMenu'

class Header extends React.Component {
  state = {
    mobileMenu: true,
    displaySearch: false,
    isTourOpen: false,
    hasOpenTour: false,
  }

  onExpandMenu = (e) => {
    e.preventDefault()
    const type = 'campus-recommendation'
    triggerEvent('ga/global/button-navbar/directory')

    if (this.checkTour(type) && !this.checkHasOpenTour()) {
      const options = {
        headers: { 'X-CSRF-Token': csrfToken() },
      }
      API.post(API.endPoints({ type }).auth.onboarding_tooltip, {}, options).then(() => {
        this.setState({ isTourOpen: true, hasOpenTour: true })
      })
      window.addEventListener('click', this.openDropdown)
      detectStopScroll(this.disableBody)
    }
  }

  closeTour = () => {
    this.setState({ isTourOpen: false })
    document.body.style.overflow = ''
    window.removeEventListener('click', this.openDropdown)
  }

  disableBody = () => {
    if (this.state.isTourOpen) {
      document.body.style.overflow = 'hidden'
    }
  }

  openDropdown = () => {
    document.getElementsByClassName('dropdown')[0].className += ' open'
  }

  checkHasOpenTour = () => {
    const isExpand = document.getElementsByClassName('dropdown-toggle')[0].getAttribute('aria-expanded') || false
    const { hasOpenTour } = this.state
    return !((isExpand && !hasOpenTour))
  }

  checkTour = (type) => {
    const { onboardingTooltip, takeTest } = this.props
    return !!(onboardingTooltip && !onboardingTooltip.includes(type) && takeTest)
  }

  setmobileMenu = (state) => {
    this.setState({ mobileMenu: state })
  }

  toggleSearch = () => {
    const { displaySearch } = this.state
    if (displaySearch) {
      this.setState({
        mobileMenu: true,
        displaySearch: false,
      })
    } else {
      this.setState({
        mobileMenu: false,
        displaySearch: true,
      })
    }
  }

 render() {
  const isMobileView = isDOMAvailable && window && window.outerWidth < 768
  const interestSelector = isMobileView ? '.nav-item:nth-child(9)' : '.dropdown-item:nth-child(4)'
  const interestPosition = isMobileView ? 'top' : 'left'
  const tourProps = {
    isOpen: this.state.isTourOpen,
    onRequestClose: this.closeTour,
    showNavigation: false,
    showNumber: false,
    showButtons: false,
    showCloseButton: false,
    showNavigationNumber: false,
    disableInteraction: true,
    disableKeyboardNavigation: true,
    rounded: 4,
    closeWithMask: false,
    steps: [
      {
        selector: interestSelector,
        content: () => (
          <>
            <OnboardingTooltip
              text="Ada yang baru nih! Kamu bisa melihat kampus yang kamu minati dari Tes Minat Bakat di sini"
              arrow="bottom"
              completeFunc={this.closeTour}
            />
            <style jsx>
              {`
                @media screen and (min-width: 768px) {
                  :global(.reactour__helper) {
                    top: -2%;
                  }
                  :global(.onboarding-tooltip.bottom::after) {
                    left: 98% !important;
                    bottom: 50% !important;
                    transform: rotate(90deg) !important;
                  }
                }
              `}
            </style>
          </>
        ),
        style: {
          padding: '16px',
          boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.1)',
        },
        position: interestPosition,
      },
    ],
  }
  const { fixed } = this.props
  return (
    <div id="header">
      <Tour {...tourProps} />
      <Navbar light full fixed="top">
        <div className="nav-inner-container">
          <NavbarBrand className="lg-up-m-r-lg" href="/" onClick={() => triggerEvent('ga/global/button-navbar/home')}>
            <Image src="/assets/img/logo/qc_logo_c.svg" className="campus-logo hidden-md-down" alt="Quipper Campus Logo"/>
            <Image src="/assets/img/logo/qc_small_logo_gradient.png" className="hidden-lg-up mobile-nav-logo" alt="Quipper Campus Logo"/>
          </NavbarBrand>

          <Nav navbar className="nav-autocomplete">
            <Search displayAutocomplete={this.state.displaySearch} sideEffect={this.toggleSearch} />
          </Nav>

          <Nav navbar right >
            <DesktopMenu dropdownOnClick={this.onExpandMenu}/>
            <MobileMenuToggler className="mobile-menu-toggler" hidden={!this.state.mobileMenu} dropdownOnClick={this.onExpandMenu} drawerId="#drawer-header"/>
            {
              !this.state.mobileMenu &&
              <NavItem className="hidden-lg-up" >
                <NavLink>
                  <HamburgerBtn active={this.state.displaySearch} onClick={this.toggleSearch} />
                </NavLink>
              </NavItem>
            }
          </Nav>
        </div>
      </Navbar>
      <MobileMenu drawerId="drawer-header" />
      <style jsx>
        {`
          :global(.nav-link) {
            display: block;
          }
          :global(.autocomplete-nav) {
            @media(min-width: 992px) {
              width: 75%;
            }
          }
          :global(.navbar) {
            transform: translateY(${!fixed ? '-100%' : 0});
            transition: transform .2s ease;
          }
        `}
      </style>
    </div>
  )
 }
}

Header.propTypes = {
  fixed: bool,
  takeTest: bool,
  onboardingTooltip: array,
}

export { Header }
export default branch({
  takeTest: ['serverProps', 'currentUser', 'take_test'],
  onboardingTooltip: ['serverProps', 'currentUser', 'tooltip'],
}, Header)
